const { map } = require('lodash');

function createInspirationTile(inspirationTile, type = 'inspiration') {
    return {
        id: inspirationTile.ID,
        type,
        data: { inspirationTile },
    };
}

function createInspirationTiles(inspirationTiles, type) {
    return map(inspirationTiles, inspirationTile => createInspirationTile(inspirationTile, type));
}

module.exports = {
    createInspirationTile,
    createInspirationTiles,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/inspiration-tile-factory.js